/* istanbul ignore file */
import SortOrderStorage from './SortOrderStorage';

export default {
    install(Vue) {
        // eslint-disable-next-line no-param-reassign
        Vue.prototype.$sortOrderStorage = new SortOrderStorage();
    },
};
